/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Fact_No_AccountInputs */

const en_coaches_page_fact_no_account = /** @type {(inputs: Coaches_Page_Fact_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse without an account`)
};

const pl_coaches_page_fact_no_account = /** @type {(inputs: Coaches_Page_Fact_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądasz bez zakładania konta`)
};

/**
* | output |
* | --- |
* | "Browse without an account" |
*
* @param {Coaches_Page_Fact_No_AccountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_fact_no_account = /** @type {((inputs?: Coaches_Page_Fact_No_AccountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Fact_No_AccountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_fact_no_account(inputs)
	return en_coaches_page_fact_no_account(inputs)
});